import type { PropsWithChildren } from "react";

import { cn } from "@/components/podkit/lib/cn";

export function StepSubheader({ children, className }: PropsWithChildren<{ className?: string }>) {
    return <h2 className={cn("text-center text-lg text-content-muted", className)}>{children}</h2>;
}
